{
  "dss": {
    "button": {
      "back": "Nazaj",
      "cancel": "Prekliči",
      "close": "Zapri",
      "confirmDelete": "Da, izbriši",
      "continue": "Nadaljuj",
      "logout": "Odjava",
      "passwordReset": "Ponastavitev gesla",
      "save": "Shrani",
      "verify": "Potrdi"
    },
    "error": {
      "403": "Nimate dostopa do te strani.",
      "404": "Ta stran ne obstaja.",
      "generic": "Prišlo je do napake. Poskusite znova pozneje.",
      "invalidConfirmationLink": "Povezava za potrditev je potekla ali je neveljavna.",
      "throttling": "Preveč poskusov. To dejanje je začasno blokirano.",
      "title": "Napaka",
      "title403": "Dostop zavrnjen",
      "title404": "Ni najdeno"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Politika zasebnosti",
      "terms": "Pogoji in določila"
    },
    "label": {
      "CRMAccountNumber": "Številka računa CRM",
      "contact": "Kontakt",
      "email": "E-pošta",
      "faq": "FAQ",
      "female": "Ga.",
      "firstname": "Ime",
      "help": "Pomoč",
      "language": "Jezik",
      "lastname": "Priimek",
      "male": "G.",
      "needHelp": "Potrebujete pomoč?",
      "newPassword": "Novo geslo",
      "newPassword2": "Potrdite novo geslo",
      "oldPassword": "Trenutno geslo",
      "organization": "Organizacija",
      "password": "Geslo",
      "required": "obvezno",
      "salutation": "Nagovor",
      "select": "Prosimo izberite"
    },
    "lang": {
      "de": "Nemščina"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Potrdite registracijo",
        "wait": "Prosimo, počakajte, da se potrditev računa zaključi."
      },
      "otp": {
        "btnResend": "Znova pošlji potrditveno kodo",
        "msg": {
          "invalidOTP": "Vneseno enkratno geslo ni veljavno.",
          "resendFail": "Ponovno pošiljanje kode ni uspelo. Poskusite znova pozneje."
        },
        "spamDetail": "Preverite mapo »Prejeto« in »Neželena pošta« za e-pošto od STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Niste prejeli e-pošte?",
        "subtitle": "Za nadaljevanje morate potrditi svoj e-poštni naslov.",
        "title": "Potrdite svoj uporabniški račun",
        "txtVerifyMail": "Vnesite novo potrditveno kodo, poslano na vaš e-poštni naslov {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Ni kaj posodobiti.",
          "updateError": "Osebnih podatkov ni bilo mogoče posodobiti.",
          "updated": "Osebni podatki so posodobljeni.",
          "userLoadErr": "Pri nalaganju uporabniških podatkov je prišlo do napake. Poskusite znova pozneje."
        },
        "secOrganization": "Organizacija",
        "secPersonal": "Osebno",
        "secSettings": "Prednostne nastavitve",
        "title": "Osebni podatki"
      },
      "postPwSet": {
        "info": "Zdaj lahko uporabljate svoje novo geslo.",
        "link_name": "Nadaljuj na Self-Service",
        "link_url": "/user/ui/",
        "title": "Vaše geslo je bilo spremenjeno"
      },
      "resetPW": {
        "title": "Ponastavite svoje geslo"
      },
      "security": {
        "2fa": {
          "availableMethods": "Razpoložljive metode 2FA:",
          "info": "Dvofaktorska avtentikacija (2FA) je varnostna funkcija, ki vašemu računu doda dodatno plast zaščite. Namesto samo uporabniškega imena in gesla zahteva uporabo dveh metod prijave.",
          "method": {
            "email": "E-pošta",
            "emailDesc": "Prejmite enkratne kode po e-pošti za dokončanje zahtev za avtentikacijo.",
            "oath": {
              "add": {
                "button": "Registriraj aplikacijo Authenticator"
              }
            }
          }
        },
        "authenticator": "Aplikacija Authenticator",
        "infoFederatedAccount": "Ta račun upravlja ponudnik identitete vaše organizacije, zato gesla tukaj ni mogoče spremeniti. Če želite spremeniti geslo, se prijavite prek prijavne strani vaše organizacije ali se obrnite na skrbnika IT.",
        "lastUse": "Zadnja uporaba: {0}.",
        "msg": {
          "invalidPassword": "Vneseno trenutno geslo je neveljavno.",
          "passwordAlreadyUsed": "Ni mogoče ponovno uporabiti zadnjih 5 gesel.",
          "pwUpdateError": "Pri poskusu spremembe gesla je prišlo do napake.",
          "pwUpdated": "Geslo je bilo spremenjeno."
        },
        "noDevice": "Ni konfigurirano",
        "oathAdd": {
          "appInfo": "Za lažji prijavni postopek v STIHL lahko uporabite aplikacije Authenticator, kot so {0}, {1}, {2} itd., za generiranje enkratnih gesel, ki se uporabljajo kot drugi faktor med prijavo.<br/>Če ste izgubili ali pozabili svojo mobilno napravo, lahko vedno uporabite 2FA kodo, poslano po e-pošti.<br/><br/>Sledite spodnjim navodilom za nastavitev svoje avtentikacijske naprave.",
          "badCode": "Neveljavna koda, poskusite znova.",
          "error": "Pri poskusu registracije avtentikacijske naprave je prišlo do napake.",
          "headScan": "1. Svoje aplikacijo Authenticator uporabite za skeniranje QR kode",
          "headVerify": "2. Potrdite kodo",
          "infoKey": "nastavitveni ključ",
          "infoKeyTitle": "Vaša dvofaktorska skrivnost",
          "infoScanBottom": "Ne morete skenirati? Uporabite {0} za ročno konfiguracijo aplikacije Authenticator.",
          "infoVerify": "Vnesite kodo, ki jo generira vaša aplikacija Authenticator.",
          "success": "Vaša avtentikacijska naprava je registrirana. Zdaj jo lahko uporabite za prijavo.",
          "title": "Registrirajte svojo napravo za dvofaktorsko avtentikacijo"
        },
        "oathDelete": {
          "error": "Pri poskusu brisanja avtentikacijske naprave je prišlo do napake.",
          "success": "Avtentikacijska naprava je bila izbrisana."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey so pari kriptografskih ključev (javni in zasebni ključ), ki jih shranjuje avtentikator pod vašim nadzorom. Avtentikator lahko dokaže, da je uporabnik prisoten in pooblaščen za uporabo passkeyja. Avtentičnost se dokazuje s PINom, kodo, biometrijo ali geslom naprave, odvisno od zmožnosti in konfiguracije avtentikatorja. Avtentikatorji so različni: iPhone ali Android naprava, Windows Hello, FIDO2 strojni varnostni ključ ali upravljalnik gesel.",
            "info2": "Ko se prijavite v STIHL s passkeyjem, vaš avtentikator uporablja kriptografijo z javnim ključem, da dokaže vašo identiteto STIHLu, ne da bi kdaj poslal sami passkey. Passkeyji so vezani na domeno spletne strani, kot je stihl-sso.com, in zahtevajo varno povezavo, kar pomeni, da bo brskalnik zavrnil avtentikacijo na podobni phishing strani. Te lastnosti naredijo passkeyje zelo odporne na phishing in veliko težje napadljive kot SMS ali TOTP 2FA.",
            "info3": "Storitve passkey s podporo za oblak omogočajo sinhronizacijo ključev med napravami (npr. Apple, Android ali upravljalniki gesel), tako da jih je mogoče uporabljati na več mestih in se težje izgubijo. Ko nastavite sinhroniziran passkey na eni napravi, je na voljo na več napravah, ki uporabljajo isto storitev. Na primer, če registrirate passkey v svojem iCloud računu s pomočjo Touch ID na vašem MacBooku, lahko ta passkey nato uporabljate z obrazom, prstnim odtisom, PINom ali geslom naprave na več napravah, povezanih z istim iCloud računom.",
            "title": "O Passkeys"
          },
          "add": {
            "button": "Dodaj nov Passkey",
            "error": "Pri dodajanju novega passkeyja je prišlo do napake.",
            "success": "Nov passkey je dodan."
          },
          "delete": {
            "button": "Izbriši Passkey",
            "error": "Pri brisanju tega passkeyja je prišlo do napake.",
            "success": "Passkey je bil izbrisan."
          },
          "edit": {
            "error": "Pri shranjevanju imena passkeyja je prišlo do napake.",
            "name": "Ime Passkey",
            "success": "Ime passkeyja je posodobljeno.",
            "title": "Dajte svojemu Passkeyju ime, da ga ločite od drugih"
          },
          "info": "Passkey je preprosta in varna alternativa geslom, ki preverja vašo identiteto z dotikom, prepoznavo obraza, geslom naprave ali PINom.",
          "none": "Ni konfiguriranega Passkeyja.",
          "reallyDelete": "Ali ste prepričani, da želite izbrisati Passkey?",
          "registeredPasskeys": "Vaši registrirani Passkeyji:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Ali ste prepričani, da želite izbrisati avtentikacijsko napravo?",
        "secMFA": "Dvofaktorska avtentikacija",
        "secPwdChange": "Spremeni geslo",
        "title": "Varnost"
      },
      "setPW": {
        "acceptTC": "Prosimo, potrdite naše {terms} in preberite našo {privacy}.",
        "killSSO": "Razveljavi vse aktivne seje",
        "msg": {
          "tokenExpired": "Povezava ali koda za geslo je potekla. Prosimo, sledite povezavi za ponastavitev gesla: {link}."
        },
        "privacy": "Politika varstva podatkov",
        "terms": "Pogoji in določila",
        "title": "Vnesite novo geslo"
      }
    },
    "validations": {
      "hasDigit": "Mora vsebovati številko(e)",
      "hasLowercase": "Mora vsebovati male črke",
      "hasSpecial": "Mora vsebovati posebne znake: {chars}",
      "hasUppercase": "Mora vsebovati velike črke",
      "invalidCharacters": "Vsebuje neveljavne znake",
      "maxLength": "Dovoljenih je največ {max} znakov",
      "minLength": "Zahtevani so najmanj {min} znaki",
      "notSameAsEmail": "Preveč podobno e-poštnemu naslovu",
      "onlyValidCharactersAllowed": "Dovoljene so samo črke, številke in presledki.",
      "required": "Obvezno polje",
      "sameAsPassword": "Gesli se ne ujemata",
      "tcAccepted": "Prosimo, potrdite naše pogoje in določila.",
      "validEmail": "Neveljaven e-poštni naslov.",
      "validOTP": "Prosimo, vnesite potrditveno kodo."
    }
  }
}
